(() => {
  'use strict';
  function init() {
    const root = document.querySelector('[data-onair-cart-fitment]');
    let form = document.querySelector('#MainContent form#cart');
    if (!root || !form || root.dataset.onairV61Saver === '1') return;
    root.dataset.onairV61Saver = '1';
    const inputs = Array.from(root.querySelectorAll('input[name^="attributes["]'));
    const required = Array.from(root.querySelectorAll('input[data-fitment-required]'));
    let checkout = document.querySelector('#MainContent #cartCheckout');
    if (!required.length || !checkout) return;

    const message = document.createElement('div');
    message.className = 'onair-v61-save-feedback';
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.dataset.state = 'pending';
    const heading = document.createElement('strong');
    const detail = document.createElement('span');
    message.append(heading, detail);
    const statePanel = root.querySelector('[data-fitment-status]');
    if (statePanel) statePanel.insertAdjacentElement('afterend', message);
    else root.querySelector('[data-onair-fitment-fields]')?.insertAdjacentElement('afterend', message);

    const prefix = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    let saved = '';
    let writing = null;
    let timer = 0;
    let forwarding = false;
    let finishing = false;

    function active() {
      return !root.hidden && required.length > 0;
    }
    function filled() {
      return required.every(input => !input.disabled && !!input.value.trim() && input.checkValidity());
    }
    function attributes() {
      const values = {};
      inputs.forEach(input => {
        if (input.disabled) return;
        const match = /^attributes\[(.+)\]$/.exec(input.name);
        if (match) values[match[1]] = input.value.trim();
      });
      return values;
    }
    function signature() { return JSON.stringify(attributes()); }
    function description() {
      const values = attributes();
      if (values['Vehicle Year'] && values['Vehicle Make'] && values['Vehicle Model']) {
        return [values['Vehicle Year'], values['Vehicle Make'], values['Vehicle Model'], values['Vehicle Trim or Chassis']].filter(Boolean).join(' ');
      }
      const groups = root.querySelectorAll('[data-onair-fitment-item]');
      return groups.length === 1 ? '1 vehicle-specific kit' : groups.length + ' vehicle-specific kits';
    }
    function notify(state, title, copy) {
      message.dataset.state = state;
      heading.textContent = title;
      detail.textContent = copy || '';
      const button = document.querySelector('#MainContent #cartCheckout');
      if (!button) return;
      let notice = button.parentElement?.querySelector('[data-onair-checkout-progress]');
      if (!notice) {
        notice = document.createElement('p');
        notice.className = 'onair-v62-checkout-progress';
        notice.dataset.onairCheckoutProgress = 'true';
        notice.setAttribute('role', 'status');
        notice.setAttribute('aria-live', 'polite');
        button.insertAdjacentElement('afterend', notice);
      }
      notice.dataset.state = state;
      notice.hidden = state !== 'saving' && state !== 'error';
      notice.textContent = state === 'saving'
        ? 'Saving your vehicle details before checkout. Please wait.'
        : state === 'error'
          ? 'Vehicle details could not be saved. Tap Check out to retry.'
          : '';
    }
    function updateCartVehicleLines(confirmed) {
      const values = attributes();
      const groups = Array.from(root.querySelectorAll('[data-onair-fitment-item]'));
      document.querySelectorAll('[data-onair-cart-vehicle-line]').forEach(node => {
        if (!confirmed) {
          node.textContent = 'Vehicle details are being confirmed below.';
          return;
        }
        if (groups.length) {
          const key = node.getAttribute('data-onair-cart-vehicle-line');
          const rows = groups.filter(group => group.dataset.onairFitmentItem === key).map(group => {
            const prefix = 'ONAIR Kit ' + key + ' Unit ' + group.dataset.onairFitmentUnit;
            return [values[prefix + ' Year'], values[prefix + ' Make'], values[prefix + ' Model']].filter(Boolean).join(' ');
          }).filter(Boolean);
          node.textContent = rows.length ? 'Saved vehicle(s): ' + rows.join(' · ') : 'Vehicle details are confirmed below.';
        } else {
          node.textContent = 'Saved vehicle: ' + [values['Vehicle Year'], values['Vehicle Make'], values['Vehicle Model']].filter(Boolean).join(' ');
        }
      });
    }
    function announceSaved() {
      notify('saved', 'VEHICLE DETAILS SAVED TO CART', description() + '. This information will accompany your Shopify order for ONAIR fitment review.');
      updateCartVehicleLines(true);
    }
    async function writeOne(values, snapshot) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 14000);
      try {
        const response = await fetch(prefix + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({attributes: values}),
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Shopify could not confirm these vehicle details.');
        const cart = await response.json();
        const confirmed = Object.entries(values).every(([key, value]) => String(cart.attributes?.[key] ?? '') === value);
        if (!confirmed) throw new Error('The saved vehicle details did not match the entries.');
        if (signature() !== snapshot) return false;
        saved = snapshot;
        announceSaved();
        return true;
      } catch (error) {
        saved = '';
        notify('error', 'VEHICLE DETAILS NOT SAVED', 'Please retry before checkout. Your kit remains in the cart.');
        return false;
      } finally {
        clearTimeout(timeout);
      }
    }
    async function save() {
      if (!active()) return true;
      if (!filled()) {
        saved = '';
        notify('pending', 'VEHICLE DETAILS NEEDED', 'Enter your year, make and model to continue.');
        return false;
      }
      const fingerprint = signature();
      if (saved === fingerprint) return true;
      if (writing) {
        await writing.catch(() => false);
        return save();
      }
      const values = attributes();
      notify('saving', 'SAVING VEHICLE DETAILS', 'Checking that Shopify has received your vehicle information.');
      const task = writeOne(values, fingerprint);
      writing = task;
      try {
        await task;
      } finally {
        if (writing === task) writing = null;
      }
      if (signature() !== fingerprint) return save();
      return saved === fingerprint;
    }
    function changed() {
      saved = '';
      updateCartVehicleLines(false);
      clearTimeout(timer);
      if (!active()) return;
      if (!filled()) {
        notify('pending', 'VEHICLE DETAILS NEEDED', 'Complete your year, make and model.');
        return;
      }
      notify('saving', 'SAVING VEHICLE DETAILS', 'Your vehicle information is being attached to this cart.');
      timer = setTimeout(() => { void save(); }, 650);
    }
    root.addEventListener('input', changed);
    root.addEventListener('change', changed);

    async function proceedToCheckout() {
      if (finishing || !active()) return;
      if (!filled()) {
        notify('pending', 'VEHICLE DETAILS NEEDED', 'Complete the required vehicle fields before checkout.');
        const field = required.find(input => !input.value.trim() || !input.checkValidity());
        field?.focus({preventScroll: true});
        root.scrollIntoView({behavior: 'smooth', block: 'start'});
        field?.reportValidity();
        return;
      }
      if (document.querySelector('#MainContent cart-items.disabled')) {
        notify('error', 'CART STILL UPDATING', 'Let the quantity or item changes finish, then tap Check out again.');
        return;
      }
      finishing = true;
      clearTimeout(timer);
      const liveButton = document.querySelector('#MainContent #cartCheckout');
      const liveLabel = liveButton?.querySelector('span');
      const originalLabel = liveLabel?.textContent || '';
      liveButton?.setAttribute('aria-busy', 'true');
      if (liveLabel) liveLabel.textContent = 'Opening secure checkout...';
      try {
        const ok = await save();
        if (!ok || !filled() || saved !== signature()) {
          notify('error', 'VEHICLE DETAILS NOT SAVED', 'Please check your vehicle details, then tap Check out again.');
          return;
        }
        const noteField = document.querySelector('#MainContent #cart-note');
        if (noteField) {
          const noteValue = noteField.value;
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), 14000);
          try {
            const response = await fetch(prefix + 'cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              cache: 'no-store',
              headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
              body: JSON.stringify({note: noteValue}),
              signal: controller.signal
            });
            if (!response.ok) throw new Error('Could not save the cart note.');
            const cart = await response.json();
            if (String(cart.note ?? '') !== noteValue) throw new Error('Cart note confirmation failed.');
            if (noteField.value !== noteValue) throw new Error('The cart note changed during checkout.');
          } finally {
            clearTimeout(timeout);
          }
        }
        if (!filled() || saved !== signature() || !active()) {
          notify('error', 'VEHICLE DETAILS CHANGED', 'Please confirm your vehicle details and try checking out again.');
          return;
        }
        window.location.assign(prefix + 'checkout');
      } catch (error) {
        notify('error', 'CHECKOUT NOT READY', 'We could not finish saving your cart. Please try again. Your items are still in the cart.');
      } finally {
        finishing = false;
        const button = document.querySelector('#MainContent #cartCheckout');
        button?.removeAttribute('aria-busy');
        const label = button?.querySelector('span');
        if (label && originalLabel) label.textContent = originalLabel;
      }
    }

    document.addEventListener('click', event => {
      const target = event.target.closest?.('#MainContent #cartCheckout');
      if (!target || !active()) return;
      if (!filled()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      void proceedToCheckout();
    }, true);

    document.addEventListener('submit', event => {
      form = document.querySelector('#MainContent form#cart');
      checkout = document.querySelector('#MainContent #cartCheckout');
      if (!form || !checkout || event.target !== form || !active()) return;
      if (event.submitter && event.submitter.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      void proceedToCheckout();
    }, true);

    async function checkExisting() {
      if (!active()) return;
      if (!filled()) {
        notify('pending', 'VEHICLE DETAILS NEEDED', 'Complete your year, make and model.');
        return;
      }
      const before = signature();
      try {
        const response = await fetch(prefix + 'cart.js', {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
        if (!response.ok) throw new Error('Cart check failed');
        const cart = await response.json();
        if (before !== signature()) return;
        const present = Object.entries(attributes()).every(([key, value]) => String(cart.attributes?.[key] ?? '') === value);
        if (present) {
          saved = before;
          announceSaved();
        } else changed();
      } catch (error) {
        if (before === signature()) changed();
      }
    }
    window.addEventListener('pageshow', () => { void checkExisting(); });
    void checkExisting();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();